import crud from "../../../crud";

crud.conf['c-wait'] = {
    msg : '...',
    global : true,
}

const cWaitMixin = {

}
export default cWaitMixin
